export default {
  AdminUser: function () {
    this.id = -1;
    this.deleted = false;
    this.name = null;
    this.accessToken = null;
    this.client = null;
    this.uid = null;

    /**
     * APIから取得したデータをセットする
     * @param {*} api APIから取得した商品情報
     */
    this.setApiData = function (api) {
      if (!api) return;

      if (api['id']) this.id = api['id'];
      if (api['deleted']) this.deleted = api['deleted'];
      if (api['name']) this.name = api['name'];
      if (api['access-token']) this.accessToken = api['access-token'];
      if (api['client']) this.client = api['client'];
      if (api['uid']) this.uid = api['uid'];
    };
  },
};
